export type Page<TInput> = {
    key: string
    title: string
    render: (props: TInput) => JSX.Element
}

export type PageDescriptor = {
    key: string
    title: string
    render: () => JSX.Element
}

export function createDescriptor<TInput>(page: Page<TInput>, input: TInput): PageDescriptor {
    return { key: page.key, title: page.title, render: () => page.render(input) }
}
